import { Toast } from 'antd-mobile'
import fetch from "isomorphic-fetch";

export default class Ajax {
    hhtc_request(url,data){
        var requrl = global.httpUrl + url;
        var init={
            method: 'POST',
            headers:{
                'Content-Type': 'application/json;',
                "Accept": "application/json",
                "token": localStorage.getItem('answer_token')
            },
            body:JSON.stringify(data)
        }
        return  fetch(requrl,init).then(
             (response) => {
                return  response.json()
            }
        ).then(
            (data)=>{
                if(data.code===999){
                    if(localStorage.getItem('answer_token')){
                        localStorage.removeItem('answer_token')
                        Toast.show('登录失效！')
                        window.location.href='/login'
                    }else{
                        Toast.show('请先登录!')
                        window.location.href='/login'
                       
                    }
                    return data;
                }
                return data;
            }
        ).catch(
            (err)=>{
                console.log("执行一次网络请求:请求地址=》",requrl,"返回结果=>网络异常",err)
                var data={
                    code:0,
                    msg:'网络异常!'
                }
                return data;
            }
        )
    }
}